import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/fund/paypal_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-0323853a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "paypal-recharge"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fast-bank-banner flex-ter" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, "即入金可能、振込手数料3.4%")
  ])
], -1))
const _hoisted_3 = { class: "pay-price" }
const _hoisted_4 = { style: {"margin-right":"20px","font-size":"16px"} }
const _hoisted_5 = { class: "recharge-tips" }
const _hoisted_6 = {
  class: "flex-ter",
  style: {"margin-top":"20px"}
}
const _hoisted_7 = { class: "pay-input rel" }
const _hoisted_8 = {
  key: 0,
  class: "el-form-item__error abs",
  style: {"top":"1","left":"0px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi1" }, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "abs",
  style: {"line-height":"17px","font-size":"12px","margin-top":"6px","color":"#666666"}
}
const _hoisted_11 = { class: "paypal-btn" }
const _hoisted_12 = { class: "submit-paypal" }
const _hoisted_13 = { class: "paypal-fake" }
const _hoisted_14 = {
  key: 1,
  class: "pay-btn-content"
}
const _hoisted_15 = { class: "pay-btn-container" }
const _hoisted_16 = { class: "pay-left" }
const _hoisted_17 = { class: "pay-text" }
const _hoisted_18 = { class: "price" }
const _hoisted_19 = { class: "jpy" }
const _hoisted_20 = { class: "cny" }
const _hoisted_21 = {
  key: 0,
  class: "cny",
  style: {"margin-top":"6px"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pay-right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pay-btn submit-paypal" })
], -1))

import { formatMoney } from '@/plugins/utils'
import { t } from '@/plugins/i18n'
import { ref, reactive, watch, toRaw, nextTick, watchEffect, computed } from 'vue'
import { getClientIdApi, createPaypalWalletApi, walletPaypalCaptureApi } from '@/apis/pay'
import { ElMessage } from 'element-plus'
import { getCountryCurrency, floatingRate, floatingRateKrw, allIncludeExchangeRate } from '@/util/useYan'
import { useSite2Station, isMultiStore } from '@/store'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  props: ['isShopcart', 'remainingPrice'],
  emits: ['refresh', 'close'],
  setup(__props, { emit }) {

const props = __props

// isShopcart choice待支付 购物车

const route = useRoute()
const paypalAmount = computed(() => {
  return props.isShopcart ? Math.ceil(Math.ceil(props.remainingPrice?.cny * allIncludeExchangeRate.value) / (1 - 0.034)) : 0
})

const serveFee = computed(() => {
  if (props.isShopcart) {
    // 真实充值金额
    const a = Math.ceil(Math.ceil(props.remainingPrice?.cny * allIncludeExchangeRate.value) / (1 - 0.034))
    const b = a - props.remainingPrice.jpy
    console.log('a', a, b, props.remainingPrice)
    return b
  }
  return 0
})
// 币种
const currencyCode = computed(() => {
  const { currencyCode = 'CNY' } = route.query
  // 如果没开通多仓，直接展示人民币
  if (!isMultiStore()) return 'CNY'
  return currencyCode
})

// 判断路由上币种为韩元且要要是日本站点
const isCurrencyCodeKRW = computed(() => {
  return currencyCode.value === 'KRW' && isMultiStore()
})

const loading = ref(false)
const paypalPrice = ref()
const isShow = ref(false)
const inputPrice: any = (row: any) => {
  paypalPrice.value = paypalPrice.value.toString().match(/^\d{1,9}/g)[0]

  isShow.value = false
}
const getClientIdFn = () => {
  if (loading.value) {
    return
  }
  getClientIdApi().then(res => {
    loading.value = true
    const url = 'https://www.paypal.com/sdk/js?client-id=' + res.data + '&currency=JPY&vault=true&disable-funding=credit,card'
    loadScript(url, priceChangeButton)
  }).catch(() => {
    loading.value = true
    const clientId = 'AbV5vSJuX2yUtfLjQapEOe6Z9fe5XvQub6JURy5PwYsV1r9XYgNHrIMXQgx_Cb0aej5u_ES6AEQ84989'
    const url = 'https://www.paypal.com/sdk/js?client-id=' + clientId + '&currency=JPY&vault=true&disable-funding=credit,card'
    loadScript(url, priceChangeButton)
  })
}
let paypalOrderId = ''
const priceChangeButton = () => {
  const btn = document.querySelector('.submit-paypal')
  btn && (btn.innerHTML = '')
  const paypal = (window as any).paypal
  paypal.Buttons({
    style: {
      borderRadius: 48,
      height: 48
    },
    createOrder: function () {
      // This function sets up the details of the transaction, including the amount and line item details.
      return createPaypalWalletApi({
        originCurrencyCode: 'JPY',
        originRechargeAmount: props.isShopcart ? paypalAmount.value : paypalPrice.value,
        rechargeCurrencyCode: isMultiStore() ? currencyCode.value : undefined,
        allIncludeFlag: props.isShopcart

      }).then(res => {
        paypalOrderId = res.data.payPalOrderId
        return res.data.payPalOrderId
      })
    },
    /**
     *
     * @param data
     * 成功：
     * {
     *  orderId:xxx,
     *  paymentSource:xxx
     * }
     * 失败：
     * {
     *  debug_id: 'xxxx',
     *  details: [
     *    {
     *      description:xxxx,
     *      issue:'xxxxx'
     *    }
     *  ]
     * }
     *
     */
    onApprove: function (data: any, actions: any) {
      // console.log(data, actions)
      return walletPaypalCaptureApi({
        needValid: '',
        payPalOrderId: paypalOrderId,
        creditPaymentOption: false,
        authorizationId: '',
        rechargeCurrencyCode: currencyCode.value,
        allIncludeFlag: props.isShopcart
      }).then(() => {
        ElMessage.success(t('提交成功'))
        emit('refresh')
        emit('close')
        // emit('update:visible', false)
      })
    }
  }).render('.submit-paypal')
}

const loadScript = (url: string, callback: () => void) => {
  const script: any = document.createElement('script')
  if (script.readyState) {
    // IE
    script.onreadystatechange = () => {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null
        loading.value = false
        callback()
      }
    }
  } else {
    // 其他浏览器
    script.onload = () => {
      loading.value = false
      callback()
    }
  }
  script.src = url
  document.body.appendChild(script)
}
const changePrice = (number: any): any => {
  const num = Number(number)
  //   如果该账号支持韩元钱包，且用韩元钱包充值
  const floatingRateVal = isCurrencyCodeKRW.value ? floatingRateKrw.value : floatingRate.value
  let value = Math.floor(num * (1 - 0.034) / floatingRateVal * 100) / 100
  //   韩元取整，舍弃小数
  if (isCurrencyCodeKRW.value) {
    value = parseInt(String(value))
  }
  return value
}

getClientIdFn()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_loading = _resolveDirective("loading")!

  return (!__props.isShopcart)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('振込金額(日本円)')), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('Paypal入金后，如果返金情况，手续费扣除不能返还')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_input, {
                id: "inputNumber",
                modelValue: paypalPrice.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((paypalPrice).value = $event)),
                min: 1,
                onInput: inputPrice,
                style: {"width":"240px","height":"36px"}
              }, null, 8, ["modelValue"]),
              ((!paypalPrice.value || paypalPrice.value<=0) && isShow.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createTextVNode(_toDisplayString(_unref(t)('汇款金额必须大于0')), 1)
                  ]))
                : _createCommentVNode("", true),
              (paypalPrice.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString((_unref(isCurrencyCodeKRW) ? _unref(t)('预计到账KRW：X韩元') : _unref(t)('预计到账CNY：X元')).replace('X', changePrice(paypalPrice.value))), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('提交')), 1)
              ], 512), [
                [_vShow, paypalPrice.value > 0]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "paypal-fake",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isShow.value=true))
              }, [
                _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
              ], 512), [
                [_vShow, paypalPrice.value <= 0 || !paypalPrice.value],
                [_directive_loading, loading.value]
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('余额可支付JPYX，剩余需支付:').replace('X', _unref(formatMoney)(__props.remainingPrice.shopWalletJPY))), 1),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, "JPY" + _toDisplayString(_unref(formatMoney)(__props.remainingPrice.jpy)), 1),
              _createElementVNode("span", _hoisted_20, "CNY" + _toDisplayString(_unref(formatMoney)(__props.remainingPrice.cny)), 1)
            ]),
            (_unref(serveFee) > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(t)('另需paypal手续费（由paypal收取）')) + ":JPY" + _toDisplayString(_unref(formatMoney)(_unref(serveFee))), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_22
        ])
      ]))
}
}

})